import { useQuery } from "@tanstack/react-query";
import {
  FreelancerExportSearchRequest,
  getFreelancerExportList,
} from "../api/freelancer-export-api";

export const useFreelancerExportList = (
  searchRequest: FreelancerExportSearchRequest
) => {
  return useQuery({
    queryKey: ["freelancerExport", searchRequest],
    queryFn: () => getFreelancerExportList(searchRequest),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
